import VersionAdd from "../components/VersionAdd";
import VersionList from "../components/VersionList";

export default function Versions() {
  return <>
    <h2>Versions</h2>
    <div style={{ marginBottom: 10 }}><VersionAdd /></div>
    <VersionList />
  </>
}